import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const masterTheme = createTheme({
  typography: {
    fontFamily: '"Poppins", sans-serif',
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  palette: {
    primary: { main: "#6FB0F9", contrastText: "#ffffff" },
    error: { main: "#FF5574" },
    text: { primary: "#0C2236", secondary: "#5A5D76" },
    background: { default: "#F9FBFD", paper: "#ffffff" },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        outlined: {
          borderColor: "#e8eef5",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 700,
        },
      },
    },
  },
});

export default function MasterTheme({ children }: { children: React.ReactNode }) {
  return <ThemeProvider theme={masterTheme}>{children}</ThemeProvider>;
}
